export const LOADING_DELAY = 200;
export const COMPLETION_DELAY = 100;